/**
 * Clamps number so it don't overflows minimum/maximum limit
 *
 * @param n input
 * @param min maximum (inclusive)
 * @param max minimum (inclusive)
 */
export function clamp(n: number, min: number, max: number): number {
  if (min > max) throw new Error('Min should be less than maximum')
  if (n < min) return min
  if (n > max) return max
  return n
}
